import { GlobalAxios } from "../axios/axios-config";
import { ICalendarClassificationConsultation } from "../models/calendar-classification-consultation";

const CALENDAR_CLASSIFICATION_CONSULTATION_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/CalendarClassificationConsultation/CalendarClassificationConsultation";

export const calendarClassificationConsultationList = (params?: any) => {
  return GlobalAxios.get<ICalendarClassificationConsultation[]>(
    CALENDAR_CLASSIFICATION_CONSULTATION_ROUTE,
    {
      params: params,
      paramsSerializer: { indexes: null },
    }
  );
};
